import { memo } from "react";
import styled from "styled-components";
import { PiTrash, PiMagnifyingGlass, PiPen } from "react-icons/pi";
import { Comment_Base } from "~/common/typescript/models/Comment";
import { CommentAPIs } from "~/common/typescript/apis/CommentAPIs";
import { CommentItemUtil } from "./CommentItemUtil";
import { commentsAtom } from "~/components/Map/Comment/CommentStore";
import { useAtom } from 'jotai';
import { Popconfirm } from "antd";
import { CommentMapUtilOptimized } from "~/components/Map/Comment/CommentMapUtilOptimized";

type CommentItemContextMenuProps = {
  comment: Comment_Base;
  onClickEdit: Function;
  onCloseContextMenu: Function;
}
const CommentItemContextMenu = (props: CommentItemContextMenuProps) => {
  const [comments, setComments] = useAtom(commentsAtom);

  const onClick_Delete = async () => {
    const commentId = props.comment.id!;

    // Immediately close any popup for this comment BEFORE deleting
    const popup = CommentMapUtilOptimized.hashPopupByCommentId.get(commentId);
    if (popup) {
      try {
        if (typeof popup.remove === 'function') {
          popup.remove();
        }
        CommentMapUtilOptimized.hashPopupByCommentId.delete(commentId);
      } catch (error) {
        console.warn('Error closing popup before deletion:', commentId, error);
      }
    }

    // Remove label overlay if exists
    CommentMapUtilOptimized.removeLabelOverlay(commentId);

    await CommentAPIs.remote_deleteComment(commentId);
    setComments(
      comments.map((comment: Comment_Base) => {
        if (comment.id === commentId) {
          return {
            ...comment,
            is_deleted: true,
          };
        }
        return comment;
      })
    );
    props.onCloseContextMenu();
  }

  const onClick_Edit = () => {
    props.onClickEdit();
    props.onCloseContextMenu();
  }

  const onClick_ZoomTo = () => {
    CommentItemUtil.zoomToComment(props.comment);
    props.onCloseContextMenu();
  }

  return <UI_Wrapper className="map-view-panel">
    <UI_List>

      {/* Chỉnh sửa */}
      <UI_Item onClick={onClick_Edit}>
        <UI_Item_Icon>
          <PiPen />
        </UI_Item_Icon>
        <UI_Item_Text>Chỉnh sửa</UI_Item_Text>
        <UI_Item_Value>
          Insert
        </UI_Item_Value>
      </UI_Item>
      {/* End chỉnh sửa */}

      {/* Xoá */}
      <Popconfirm
        placement="top"
        title="Xoá"
        description="Bạn có chắc chắn muốn xoá?"
        okText="Xoá"
        cancelText="Huỷ"
        onConfirm={onClick_Delete}
      >
        <UI_Item>
          <UI_Item_Icon>
            <PiTrash />
          </UI_Item_Icon>
          <UI_Item_Text>Xoá</UI_Item_Text>
          <UI_Item_Value>
            Delete
          </UI_Item_Value>
        </UI_Item>
      </Popconfirm>
      {/* End Xoá */}

      {/* Zoom to */}
      <UI_Item onClick={onClick_ZoomTo}>
        <UI_Item_Icon>
          <PiMagnifyingGlass />
        </UI_Item_Icon>
        <UI_Item_Text>Phóng tới</UI_Item_Text>
        <UI_Item_Value>
          Phóng tới
        </UI_Item_Value>
      </UI_Item>
      {/* End Zoom to */}
    </UI_List>

  </UI_Wrapper>
}

export default memo(CommentItemContextMenu);

const UI_Wrapper = styled.div`
  width: 250px;
`;

const UI_List = styled.div`
  display: flex;
  flex-direction: column;
`
const UI_Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`
const UI_Item_Icon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
`

const UI_Item_Text = styled.div`
  flex: 1;
  font-size: 14px;
`
const UI_Item_Value = styled.div`
  padding: 8px;
  width: 80px;
  font-size: 14px;
  text-align: right;
  padding-right: 12px;
`
const UI_Item_Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #eaeaea;
`